<template>
    <v-card elevation="0" style="min-height: 70vh;">
        <!-- <v-col cols="12" style="height: 100%;"> -->
        <v-card elevation="0" style="margin-top: 15px;">
            <v-card-title>
                {{ $t('_evenements_o&m_notables_') }}
            </v-card-title>
        </v-card>
        <v-card style="height: 70vh;">
            <div style="display: grid; height: 100%;">
                <v-row style="margin: 0px;">
                    <v-col cols="7" class="tableau">
                        <v-data-table class="tableEvenement" :items="evenement" :headers="headerEvenement"
                            :items-per-page="-1" @click:row="editItem" fixed-header hide-default-footer
                            :item-class="getRowClass">
                            <template v-slot:top>
                                <v-toolbar flat style="background-color:#F2F4F4">
                                    <v-toolbar-title></v-toolbar-title>
                                </v-toolbar>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-icon small @click.stop="deleteItem(item)">
                                    mdi-minus-box
                                </v-icon>
                            </template>
                        </v-data-table>

                    </v-col>
                    <v-col cols="5" style="align-items: center; display: flex;">
                        <div style="width: 100%;">
                            <div class="champs">
                                <div>
                                    {{ $t("_type_d_evenement_") }} (*)
                                </div>
                                <div>
                                    <div class="input">
                                        <select class="createSelect" v-model="reponse.type.value">
                                            <option disabled value=""> </option>
                                            <option v-for="(opt, index) in optionsType" :value="opt" :key="index"> {{ opt
                                                }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="champs">
                                <div>
                                    {{ $t("_date_de_debut_") }} (*)
                                </div>
                                <div>
                                    <input class="date" type="date" v-model="reponse.dateDebut.value" />
                                </div>
                            </div>
                            <div class="champs">
                                <div>
                                    {{ $t("_date_de_fin_") }} (*)
                                </div>
                                <div>
                                    <input class="date" type="date" v-model="reponse.dateFin.value" />
                                </div>
                            </div>
                            <div v-if="this.reponse.dateFin.value !== '' && this.reponse.dateDebut.value !== '' && this.reponse.dateFin.value < this.reponse.dateDebut.value"
                                class="warn">Attention: la date de fin doit être suppérieur à celle de début</div>
                            <div v-if="reponse.type.value === 'Nettoyage centrale'" class="champs">
                                <div>
                                    {{ $t("_couts_") }} (*)
                                </div>
                                <div>
                                    <div class="input">
                                        <v-text-field label="" outlined v-model="reponse.cout.value"
                                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
                                        <div class="unit"> € </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="reponse.type.value === 'Consignes réseau (Grid)/ bridage'" class="champs">
                                <div>
                                    {{ $t("_puissance_apparente_limite_") }}
                                </div>
                                <div>
                                    <div class="input">
                                        <v-text-field label="" outlined v-model="reponse.kVA.value"
                                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
                                        <div class="unit"> kVA </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="reponse.type.value === 'Consignes réseau (Grid)/ bridage'" class="champs">
                                <div>
                                    {{ $t("_puissance_active_limite_") }}
                                </div>
                                <div>
                                    <div class="input">
                                        <v-text-field label="" outlined v-model="reponse.kW.value"
                                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
                                        <div class="unit"> kW </div>
                                    </div>
                                </div>
                            </div>
                            <div class="champs">
                                <div>
                                    {{ $t("_commentaire_") }}
                                </div>
                                <div class="input">
                                    <v-text-field class="inputField" outlined v-model="reponse.comment.value">
                                    </v-text-field>
                                </div>
                            </div>
                            <v-btn v-if="!edition" :disabled="!rempli"
                                style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw;  font-size: 1rem;"
                                @click="addData()">
                                {{ $t("_ajouter_") }}
                            </v-btn>
                            <div v-else>
                                <v-btn :disabled="!rempli"
                                    style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                                    @click="editData()">
                                    {{ $t('_modifier_') }}
                                </v-btn>
                                <v-btn :disabled="!rempli"
                                    style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                                    @click="cancelEdit()">
                                    {{ $t('_annuler_') }}
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
        <!-- </v-col> -->
    </v-card>
</template>

<script>
import backend from '@/api/backend';
// import api from "@/api/api";


export default {


    async mounted() {
        this.evenement = (await (backend.get_events_install(this.installation_id))).data
    },

    data() {
        return {
            installation_id: this.$route.params.id,
            evenement: [],
            headerEvenement: [
                { key: 'json_data.type', text: this.$t('_type_d_evenement_'), value: 'json_data.type' },
                { key: 'json_data.dateDebut', text: this.$t('_date_de_debut_'), value: 'json_data.dateDebut' },
                { key: 'json_data.dateFin', text: this.$t('_date_de_fin_'), value: 'json_data.dateFin' },
                { key: 'json_data.cout', text: this.$t('_couts_'), value: 'json_data.cout' },
                { key: 'json_data.kVA', text: this.$t('_puissance_apparente_limite_'), value: 'json_data.kVA' },
                { key: 'json_data.kW', text: this.$t('_puissance_active_limite_'), value: 'json_data.kW' },
                { key: 'json_data.comment', text: this.$t('_commentaire_'), value: 'json_data.comment' },
                { key: 'actions', text: '', value: 'actions', sortable: false },
            ],
            optionsType: [
                "Changement de matériels",
                "Heure prix négatif",
                "Nettoyage centrale",
                "Incidents connus",
                "Inspection site",
                "Consignes réseau (Grid)/ bridage"
            ],
            rempli: false,
            edition: false,
            indexEdite: null,
            reponse: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "type": {
                    "value": "",
                    "required": true,
                },
                "dateDebut": {
                    "value": "",
                    "required": true,
                },
                "dateFin": {
                    "value": "",
                    "required": true,
                },
                "cout": {
                    "value": "",
                    "required": false,
                },
                "kVA": {
                    "value": "",
                    "required": false,
                },
                "kW": {
                    "value": "",
                    "required": false,
                },
                "comment": {
                    "value": "",
                    "required": false,
                },

            },
            reponseVide: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "type": {
                    "value": "",
                    "required": true,
                },
                "dateDebut": {
                    "value": "",
                    "required": true,
                },
                "dateFin": {
                    "value": "",
                    "required": true,
                },
                "cout": {
                    "value": "",
                    "required": false,
                },
                "kVA": {
                    "value": "",
                    "required": false,
                },
                "kW": {
                    "value": "",
                    "required": false,
                },
                "comment": {
                    "value": "",
                    "required": false,
                },
            },

        };
    },

    computed: {
    },

    watch: {
        reponse: {
            handler() {
                let nouveauRempli = true
                for (var champs in this.reponse) {
                    if (this.reponse[champs].required === true && this.reponse[champs].value === "") {
                        nouveauRempli = false
                    }
                }
                if (this.reponse.type.value === "Nettoyage centrale") {
                    if (this.reponse.cout.value === "") {
                        nouveauRempli = false
                    }
                }
                else if (this.reponse.type.value === "Consignes réseau (Grid)/ bridage") {
                    if (this.reponse.kVA.value === "" && this.reponse.kW.value === "") {
                        nouveauRempli = false
                    }
                }
                if (this.reponse.dateFin.value < this.reponse.dateDebut.value)
                    nouveauRempli = false
                this.rempli = nouveauRempli
            },
            deep: true
        },
    },

    methods: {
        editItem(item) {
            this.edition = true
            this.indexEdite = this.evenement.indexOf(item)
            for (var champ in item.json_data) {
                this.reponse[champ].value = item.json_data[champ]
            }

        },

        async editData() {
            if (this.rempli) {
                // this.reponse.id.value = this.evenement.length + 1
                var justeValeurs = {}
                for (var champ in this.reponse) {
                    justeValeurs[champ] = this.reponse[champ].value
                }
                await backend.put_event_id(this.evenement[this.indexEdite].id, this.installation_id, justeValeurs)
                this.evenement = (await backend.get_events_install(this.installation_id)).data
                // for (var champ in this.reponse){
                //     this.evenement[this.indexEdite][champ]= this.reponse[champ].value
                // }
                this.edition = false
                this.$nextTick(() => {
                    for (var champ in this.reponseVide) {
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }

                })
            }
            this.indexEdite = null
            this.$forceUpdate()
        },
        async addData() {
            if (this.rempli) {
                this.reponse.id.value = this.evenement.length + 1
                var justeValeurs = {}
                for (var champ in this.reponse) {
                    justeValeurs[champ] = this.reponse[champ].value
                }
                await backend.post_event_install(this.installation_id, justeValeurs)
                this.evenement = (await backend.get_events_install(this.installation_id)).data
                // this.evenement.push(justeValeurs)
                this.$nextTick(() => {
                    for (var champ in this.reponseVide) {
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }

                })
            }
            this.$forceUpdate()
        },
        async deleteItem(item) {
            await backend.delete_event_id(item.id, this.installation_id)
            try {
                this.evenement = (await backend.get_events_install(this.installation_id)).data
            }
            catch {
                this.evenement = []
            }
            // this.evenement.splice(this.evenement.indexOf(item), 1)
            // this.$nextTick(() => {
            //     for (var i=0; i<this.evenement.length; i+=1){
            //         this.evenement[i].id = i + 1
            //     }
            // })
            if (this.edition === true) {
                this.edition = false
                this.$nextTick(() => {
                    for (var champ in this.reponseVide) {
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }

                })
            }
            this.$forceUpdate()
        },
        cancelEdit() {
            this.edition = false
            this.indexEdite = null
            this.$nextTick(() => {
                for (var champ in this.reponseVide) {
                    this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                }

            })
        },
        getRowClass(item) {
            let index = this.evenement.indexOf(item)
            return index === this.indexEdite ? 'highlighted-row' : ''
        }
    }
};
</script>

<style scoped>
.v-card__subtitle,
.v-card__text,
.v-card__title {
    padding: 16px 16px 16px 16px;
    border-bottom: #eee solid 1px;
}

.tableEvenement>>>.highlighted-row {
    background-color: #d9d9d9 !important;
}


.tableEvenement {
    border: grey 1px solid;
    height: 80%;
    overflow-x: hidden;
}

.tableau {
    align-content: center;
    height: 100%;
}

.tableau .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47, 47, 47, 0.5);
    border-radius: 5px;
}

.tableau .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}
</style>